
import { defineComponent } from "@vue/runtime-core";
import * as Modals from "@/utils/Modals";
import { getAttachmentManager } from "@/firebase/AttachmentManager";

export default defineComponent({
  components: {},
  props: ["result"],
  methods: {
    displayPictures() {
      Modals.openGallery(
        this.result.pictures.map((x) => x.url),
        this.onImageError
      );
    },
    async onImageError(src: string) {
      var res = this.result.pictures.find((x) => x.url == src);
      let newUrl = await getAttachmentManager().getDownloadUrl(
        res.firebase_path
      );

      res.url = newUrl;
      var carousel = document.body.querySelector(".se-carousel");
      carousel.parentNode.removeChild(carousel);
      Modals.openGallery(
        this.result.pictures.map((x) => x.url),
        this.onImageError
      );
    },
  },
});
